import Stack from "./Stack.js";
import Pallet from "./Pallet.js";
export default class Row {
  constructor(stack, top) {
    //initiate with one stack
    this.stacks = [stack];
    this.top = top;
    this.bottom = this.getBottom();
  }

  static getProducts(rows) {
    let products = [];
    rows.forEach(row => {
      row.stacks.forEach(stack => {
        stack.products.forEach(product => {
          products.push(product);
        });
      });
    });
    return products;
  }

  static getRows(products) {
    let rows = [];
    products.sort((a, b) => {
      return a.y - b.y;
    });
    products = products.filter(product => {
      return product.pallet_id != null;
    });
    products.forEach(product => {
      const foundRow = rows.find(e => {
        return Math.abs(e.top - product.y) <= Math.floor(80 / product.divider);
      });
      //new row
      if (!foundRow) {
        rows.push(new Row(new Stack(product), product.y));
      } else {
        const foundStack = foundRow.stacks.find(e => {
          return e.x == product.x && e.y == product.y;
        });
        //if we find a stack, add on top of it
        if (foundStack) {
          foundStack.addToStack(product);
        } else {
          //else, add new stack to rows
          foundRow.addStack(new Stack(product));
        }
      }
    });
    rows.sort((a, b) => {
      return a.top - b.top;
    });
    return rows;
  }

  addStack(stack) {
    this.stacks.push(stack);
    this.bottom = this.getBottom();
  }

  getTop() {
    return this.stacks[0].getTop();
  }

  getBottom() {
    let bottom = 0;
    this.stacks.forEach(stack => {
      bottom = Math.max(bottom, stack.getBottom());
    });
    return bottom;
  }

  getWidth() {
    let width = 0;
    this.stacks.forEach(stack => {
      width = Math.max(width, stack.x + stack.getWidth());
    });
    return width;
  }

  getMovingTop(movingStack) {
    let stack = null;
    for (let i = 0; i < this.stacks.length; i++) {
      //checks if not the one currently moving
      if (this.stacks[i].id != movingStack.id) {
        stack = this.stacks[i];
        break;
      }
    }
    return stack ? stack.getTop() : 0;
  }

  getMovingBottom(movingStack) {
    let bottom = 0;
    this.stacks.forEach(stack => {
      if (stack.id != movingStack.id) {
        bottom = Math.max(bottom, stack.getBottom());
      }
    });
    return bottom;
  }

  getHeight() {
    let height = 0;
    this.stacks.forEach(stack => {
      height = Math.max(height, stack.getBottomProduct().depth);
    });
    return height;
  }

  static minWidth(rows, pallet) {
    let width = pallet.spacing_ends;
    rows.forEach(row => {
      row.stacks.forEach(stack => {
        width = Math.max(width, stack.x + stack.width + pallet.spacing_ends);
      });
    });
    return width;
  }

  static getMovingTo(pallet, oldRows, movingStack, offsets) {
    let movingToStack = null;
    //make copies so there's no referance
    const palletCopy = new Pallet(pallet);
    let rows = Row.getRows(palletCopy.products);
    let correction = 0;
    let oldRowIndex = -1;
    let newRowIndex = -1;
    oldRows.forEach((row, i) => {
      row.stacks.forEach(stack => {
        if (stack.products[0].id == movingStack.products[0].id) {
          oldRowIndex = i;
        }
      });
    });
    rows.forEach((row, i) => {
      row.stacks.forEach(stack => {
        if (stack.products[0].id == movingStack.products[0].id) {
          newRowIndex = i;
        }
      });
    });
    for (let i = 1; i < rows.length; i++) {
      if (
        rows[i].getTop() - rows[i - 1].getBottom() >
        movingStack.products[0].depth &&
        rows.length <= oldRows.length &&
        oldRowIndex <= newRowIndex &&
        oldRowIndex + 1 != oldRows.length
      ) {
        correction = movingStack.products[0].depth + pallet.spacing_between;
      }
    }
    //move rows and see where the product will be
    rows = palletCopy.move(rows);
    for (let i = 0; i < rows.length; i++) {
      rows[i].stacks.forEach(stack => {
        if (stack.products[0].id == movingStack.products[0].id) {
          movingToStack = {
            x: stack.x + offsets.left,
            y: stack.y + correction + offsets.top,
            width: stack.width,
            height: stack.height
          };
        }
      });
    }
    return movingToStack; // return supposed position
  }

  static getBetweenRows(pallet, rows, stack, offsets) {
    const rowsCopy = rows.slice(); // we are slicing, so that our rows array is not affected
    let between = null;
    //don't look at moving product row if it only has one product
    const removingRow = rowsCopy.find(row => {
      for (let i = 0; i < row.stacks.length; i++) {
        if (row.stacks[i].id == stack.id && row.stacks.length == 1) {
          return true;
        }
      }
    });
    const correction = 40 / rowsCopy[0].stacks[0].products[0].divider;
    //if moving row where only one stack, remove this row from calculation
    if (removingRow) rowsCopy.splice(rowsCopy.indexOf(removingRow), 1);
    for (let i = 0; i < rowsCopy.length - 1; i++) {
      //check if between rows and not removing entire row by vogin
      if (
        stack.getVerticalMiddle() > rowsCopy[i].getMovingBottom(stack) - correction &&
        stack.getVerticalMiddle() < rowsCopy[i + 1].getMovingTop(stack) + correction &&
        rowsCopy[i + 1].getMovingTop(stack) -
        rowsCopy[i].getMovingBottom(stack) <
        stack.height
      ) {
        between = {
          x: offsets.left,
          y: rowsCopy[i].getMovingBottom(stack) + offsets.top,
          width: pallet.length,
          height: pallet.spacing_between
        };
      }
    }
    return between;
  }

  static getOnProduct(pallet, rows, stack, offsets) {
    const rowsCopy = rows.slice();
    let onProduct = null;
    const correction = 40 / rowsCopy[0].stacks[0].products[0].divider;
    for(const row of rowsCopy){
      for(const rowStack of row.stacks){
        //if near the edge of other than self stack
        if(
            stack.getHorizontalMiddle() > rowStack.x && 
            stack.getHorizontalMiddle()< rowStack.x + rowStack.getWidth() &&
            stack.y > rowStack.y - correction &&
            stack.y < rowStack.y + correction &&
            stack.id != rowStack.id
          ){
            onProduct = {
              x: rowStack.x - correction + offsets.left,
              y: rowStack.y - correction + offsets.top,
              width: rowStack.getWidth() + 2 *correction,
              height: rowStack.getBottom() - rowStack.getTop() + 2 * correction,
              stack: rowStack,
              color: 'yellow'
            }
          }
      }
    }
    return onProduct;
  }

  static getLongestRowLength(rows){
    let length = 0;
    for(const row of rows){
      let rowLength = 0;
      for(const stack of row.stacks){
        rowLength += stack.getWidth();
      }
      length = Math.max(length, rowLength);
    }
    return length;
  }
}
